<ng-container>
  <div class="impressum__view">
    <div class="dynamic__padding--md"
         fxLayout="column"
         fxLayoutAlign="start start"
         fxLayoutGap="1rem">
      <h1 class="dynamic__title">Impressum & Kontakt</h1>
      <div class="interface-impressum-dynamic__title--sm"
           fxLayout="column"
           fxLayoutAlign="start start">
        <h3 class="dynamic__title--sm" style="font-weight: 600">Rettensteiner Robert GmbH</h3>
        <span class="dynamic__title--sm">Hans Kappacherstraße 9</span>
        <span class="dynamic__title--sm">5600 Sankt Johann im Pongau</span>
        <span class="dynamic__title--sm">Salzburg, Österreich</span><br><br>
        <span class="dynamic__title--sm">Firmenbuchnummer: 586785w</span>
        <span class="dynamic__title--sm">Firmengericht: Landesgericht Salzburg<br><br></span>

        <div class="interface-impressum-dynamic__title--s m"
             fxLayout="column"
             fxLayoutAlign="start start">
          <span class="dynamic__title--sm">E-Mail: rettensteiner.office@sbg.at</span>
          <span class="dynamic__title--sm">Tel.: +43 (0) 6412 20 245</span>
        </div>

        <span class="dynamic__title--md"><br>Berechtigungen aufrecht<br><br></span>
        <span class="dynamic__title--sm">Gastgewerbe gemäß § 94 Z. 26 GewO 1994, Betriebsart: Imbiss-Stube, Berechtigungen gem. § 111 (1) Z.2 GewO 1994

Seit 30.08.2022 für den Standort
5600 St. Johann im Pongau, Hans-Kappacher-Straße 9 (kann vom Gründungsdatum abweichen)
Gewerberechtliche Geschäftsführung: Robert Rettensteiner
Berufszweig: Imbissstuben, Jausenstationen, Milchtrinkstuben</span><br>
        <span class="dynamic__title--sm"><br>GISA-Zahl: 18449549<br>Zuständige Aufsichtsbehörde: Behörde gem. ECG (E-Commerce Gesetz)

Bezirkshauptmannschaft Sankt Johann im Pongau</span><br><br>
        <span class="dynamic__title--sm">Handelsgewerbe seit 30.08.2022 für den Standort
5600 St. Johann im Pongau, Hans-Kappacher-Straße 9 (kann vom Gründungsdatum abweichen)
Gewerberechtliche Geschäftsführung: Robert Rettensteiner
Berufszweig: Einzelhandel mit Lebensmitteln</span>

        <a href="https://firmen.wko.at/rettensteiner-robert-gmbh/salzburg/?firmaid=34ffc298-4537-46d4-9fdd-2b0ea108926a" target="_blank">WKO | Rettensteiner Robert GmbH.</a>

        <span class="dynamic__title--sm"><br>GISA-Zahl: 18449525<br>Zuständige Aufsichtsbehörde: Behörde gem. ECG (E-Commerce Gesetz)

Bezirkshauptmannschaft Sankt Johann im Pongau</span>

        <span class="dynamic__title--sm"><br><br>Gewerbeordnung: www.ris.bka.gv.at</span>
        <span class="dynamic__title--sm">Wirtschaftskammer St.Johann im Pongau</span>
      </div>
      <h2 class="dynamic__title"><br>Datenschutz</h2>
      <div class="interface-datenschutz-dynamic__title--sm"
           fxLayout="column"
           fxLayoutAlign="start start">
    <span class="dynamic__title--sm">Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt.<br>
      Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.<br> Als
      Diensteanbieter sind wir für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.<br>
      Wir sind jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach
      Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.<br>Verpflichtungen zur Entfernung oder
      Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt.<br> Eine
      diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich.<br>
      Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte entfernen.<br><br></span>
        <span class="dynamic__title--sm" style="font-weight: 600;">Haftung für Links auf Webseiten Dritter</span>
        <span class="dynamic__title--sm"><br>Unser Angebot enthält Links zu externen Websites.<br>Auf den Inhalt dieser externen Webseiten
      haben wir keinerlei Einfluss.<br>Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen.<br>Für
      die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.<br>Die
      verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft.<br>Rechtswidrige
      Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.<br>Eine permanente inhaltliche Kontrolle der
      verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar.<br>Bei
      Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.<br><br></span>
        <span class="dynamic__title--sm" style="font-weight: 600;">Urheberrecht</span>
        <span class="dynamic__title--sm"><br>Die Betreiber dieser Webseite sind bemüht, stets die Urheberrechte anderer zu beachten bzw.
      auf selbst erstellte sowie lizenzfreie Werke zurückzugreifen.<br>Die durch die Seitenbetreiber erstellten Inhalte
      und Werke auf dieser Webseite unterliegen dem Urheberrecht.<br>Beiträge Dritter sind als solche
      gekennzeichnet.<br>Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
      Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.<br>Downloads
      und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.<br><br></span>
        <div class="privacy">
          <h3>Datenschutzerklärung</h3>
          <p>
            Wir legen großen Wert auf den Schutz Ihrer Daten. Nachfolgend informieren wir Sie darüber,
            welche personenbezogenen Daten bei der Nutzung dieser Website verarbeitet werden.
          </p>
          <p>
            Verantwortliche Stelle ist die Rettensteiner Robert GmbH, Hans Kappacherstraße 9,
            5600 Sankt Johann im Pongau, Österreich,
            E-Mail: <a href="mailto:rettensteiner.office@sbg.at">rettensteiner.office@sbg.at</a>,
            Tel.: <a href="tel:+43641220245">+43 (0) 6412 20 245</a>.
          </p>

          <h3>Auftragsverarbeitung</h3>
          <p>
            Diese Website wird von der
            <a href="https://skillagentur.com/home" target="_blank" rel="noopener">Skill Agentur</a>
            entwickelt, gehostet und betrieben. Die Skill Agentur handelt dabei als
            Auftragsverarbeiter gemäß Art. 28 DSGVO im Auftrag der Rettensteiner Robert GmbH.
            Sie stellt die Website bereit, wartet sie und verarbeitet in diesem Zusammenhang
            die dafür erforderlichen technischen Daten – insbesondere Server-Protokolle sowie
            die Daten, die zur Anzeige von Speiseplan und Wochenkarte nötig sind.
            Die Verarbeitung erfolgt ausschließlich nach Weisung des Verantwortlichen
            und nicht zu eigenen Werbe- oder Analysezwecken.
          </p>
          <p>
            Datenschutzanfragen zu dieser Website richten Sie bitte an
            <a href="mailto:info@skillagentur.com">info@skillagentur.com</a>.
          </p>

          <h3>Keine Analyse- oder Werbe-Cookies</h3>
          <p>
            Diese Website setzt selbst keine Cookies. Es kommen keine Analyse-, Tracking- oder
            Werbewerkzeuge Dritter zum Einsatz – insbesondere kein Google Analytics, keine Google Fonts
            und keine Google Maps. Schriften und Videos werden lokal ausgeliefert.
            Ein Cookie-Banner ist daher nicht erforderlich.
          </p>

          <h3>Server-Protokollierung</h3>
          <p>
            Beim Aufruf der Website erhebt die Skill Agentur als Auftragsverarbeiter automatisch
            technische Informationen am Webserver, etwa Browsertyp, Betriebssystem, aufgerufene Seite,
            IP-Adresse und Zeitpunkt des Zugriffs. Diese Daten sind zur Bereitstellung und Absicherung
            der Website erforderlich (berechtigtes Interesse gemäß Art. 6 Abs. 1 lit. f DSGVO).
            Sie werden nicht dazu verwendet, einzelne Personen zu identifizieren, und nicht an Dritte
            zu Werbezwecken weitergegeben, solange keine rechtswidrige Nutzung der Website vorliegt.
          </p>
          <p>
            Speiseplan und Wochenkarte werden über Systeme der Skill Agentur geladen.
            Dabei wird Ihre IP-Adresse an den Server übermittelt, der die Speiseplandaten bereitstellt.
          </p>

          <h3>Kontakt per E-Mail oder Telefon</h3>
          <p>
            Auf dieser Website gibt es kein Kontaktformular. Wenn Sie uns per E-Mail oder Telefon
            kontaktieren, verarbeiten wir die von Ihnen mitgeteilten Daten ausschließlich zur
            Bearbeitung Ihrer Anfrage. Eine Weitergabe an Dritte erfolgt nicht, außer sie ist zur
            Erfüllung gesetzlicher Pflichten oder zur Bearbeitung Ihrer Anfrage erforderlich.
          </p>

          <h3>OpenStreetMap</h3>
          <p>
            Zur Anzeige unseres Standorts ist auf der Startseite eine Karte von OpenStreetMap eingebunden
            (OpenStreetMap Foundation, St John’s Innovation Centre, Cowley Road, Cambridge CB4 0WS,
            Vereinigtes Königreich). Beim Laden der Karte wird eine Verbindung zu den Servern von
            OpenStreetMap hergestellt. Dabei können Ihre IP-Adresse und technische Browserdaten
            übermittelt werden. OpenStreetMap kann auf der eigenen Domain funktionale Cookies setzen
            (etwa zur Speicherung der Kartenansicht). Diese Cookies dienen nicht der Werbung oder
            Reichweitenmessung.
          </p>
          <p>
            Rechtsgrundlage ist unser berechtigtes Interesse, den Standort der Metzgerei nachvollziehbar
            darzustellen (Art. 6 Abs. 1 lit. f DSGVO). Weitere Informationen:
            <a href="https://wiki.osmfoundation.org/wiki/Privacy_Policy"
               target="_blank"
               rel="noopener">Datenschutzhinweise der OpenStreetMap Foundation</a>.
          </p>

          <h3>Vorbestellen und Links zu anderen Websites</h3>
          <p>
            Der Button „Vorbestellen“ führt auf das Bestellsystem unter
            <a href="https://bestellen.marktstubn.com/" target="_blank" rel="noopener">bestellen.marktstubn.com</a>.
            Diese Seite wird erst geladen, wenn Sie den Link anklicken. Für die dortige Datenverarbeitung
            gelten die Hinweise des jeweiligen Anbieters.
          </p>
          <p>
            Ebenso verlinken wir auf Facebook, Instagram, Restaurant Guru und weitere externe Angebote.
            Es sind reine Links, keine eingebetteten Plugins. Personenbezogene Daten werden an diese
            Anbieter erst übermittelt, wenn Sie den jeweiligen Link anklicken.
          </p>

          <h3>Ihre Rechte</h3>
          <p>
            Sie haben jederzeit das Recht auf Auskunft über die zu Ihrer Person gespeicherten Daten,
            auf Berichtigung, Löschung, Einschränkung der Verarbeitung, Widerspruch gegen die Verarbeitung
            sowie auf Datenübertragbarkeit, soweit die gesetzlichen Voraussetzungen vorliegen.
            Außerdem haben Sie das Recht, sich bei der österreichischen Datenschutzbehörde zu beschweren
            (<a href="https://www.dsb.gv.at" target="_blank" rel="noopener">www.dsb.gv.at</a>).
          </p>
          <p>
            Anfragen richten Sie bitte an
            <a href="mailto:info@skillagentur.com">info@skillagentur.com</a>.
          </p>
        </div>
      </div>

    </div>

  </div>
</ng-container>
